// extracted by mini-css-extract-plugin
export var headerCell = "_5l-1";
export var loadingStateCell = "_5l-4";
export var rowWrapper = "_5l-3";
export var standaloneTable = "_5l-5";
export var table = "_5l-0";
export var white = "_5l-2";